import { UploadInput } from '@inputs/UploadInput';
import StarIcon from '@icons/star_required_icon.svg?component';
import { MyFC } from '@/types/common';
import { IImageUploaderProps } from './types';

export const ImageUploader: MyFC<IImageUploaderProps> = (props) => {
  const { title = 'cover', width, height, required, styleProp, children } = props;
  return (
    <div
      className={`p-[24px] rounded-[16px] bg-white h-fit w-[288px] flex flex-col gap-y-[16px] shadow-sm sm-image-uploader ${styleProp}`}
      style={{ width, height }}
    >
      <div className="flex items-center gap-x-[8px]">
        <h6 className="uppercase default-text">{title}</h6>
        {required && <StarIcon width={12} height={12} />}
      </div>
      {children || <UploadInput {...props} />}
    </div>
  );
};
